import { defaultApi, authApi } from 'api';

// Anonymous (no auth token) — the public landing page (§6.1). Returns the narrow public DTO, or { available: false }
// for any failed gate (bad code / not published / not upcoming / not multi-club).
export const getPublicMeetSignup = async (code) => {
  return await defaultApi.get(`/public/meet-signup/${encodeURIComponent(code)}`);
};

// Authenticated — resolves the logged-in caller's relationship to this meet (meetId/clubId, host-club access, already
// registered) so the landing-page CTA can deep-link into the §6.10 app page. Call only when a token is present.
export const getPublicMeetMyStatus = async (code) => {
  return await authApi.get(`/public/meet-signup/${encodeURIComponent(code)}/my-status`);
};

// Anonymous (§6.6 / C2) — step 1 of the registration dialog. Given the meet code + an email, returns
// { status: 'known' | 'new' }. 'known' = a real, email-confirmed account (the dialog shows a password box and logs in
// via the normal /login). 'new' = no account, or only an unconfirmed/passwordless shell — the server (re)sends a
// 6-digit code (this doubles as the resend path). Routed through Auth so it can issue the code + later a token.
export const identifyMeetSignup = async (code, email) => {
  return await defaultApi.post('/Auth/meet-signup-identify', { signupCode: code, email });
};

// Anonymous (§6.6 / C2) — step 2 of the dialog for a new email: validate the 6-digit code + set name & password,
// confirming the account. Returns a LoginResponseDto (token + names + clubPermissions) so the registrant lands already
// logged in and registers their athletes through the normal authenticated flow. payload = { code, firstName, lastName,
// password }.
export const onboardMeetSignup = async (code, { confirmationCode, firstName, lastName, password, email }) => {
  return await defaultApi.post('/Auth/meet-signup-onboard', {
    signupCode: code,
    email,
    code: confirmationCode,
    firstName,
    lastName,
    password,
  });
};
